import React, { Suspense } from "react"
import { graphql, useLazyLoadQuery } from "react-relay"

import { EditProjectBudgetFormQuery } from "~/forms/ProjectBudgetForm/__generated__/EditProjectBudgetFormQuery.graphql"

import Loading from "~/common/Loading"

import { FallBackErrorBoundary } from "~/ProjectPlanner/FallbackErrorBoundry"

import ProjectBudgetForm from "./ProjectBudgetForm"

type Props = {
  onClose: () => void
  projectId: number
}

const QUERY = graphql`
  query EditProjectBudgetFormQuery($projectId: Int!) {
    current_user {
      id
      ...ProjectBudgetForm_user
    }
    projects_by_pk(id: $projectId) {
      id
      ...ProjectBudgetForm_project
    }
  }
`

const Loader = (props: Props) => {
  const { onClose, projectId } = props

  const query = useLazyLoadQuery<EditProjectBudgetFormQuery>(QUERY, {
    projectId: projectId,
  })

  return (
    <ProjectBudgetForm
      project={query.projects_by_pk}
      user={query.current_user}
      onClose={onClose}
    />
  )
}

const EditProjectBudgetForm = (props: Props) => {
  return (
    <FallBackErrorBoundary fallback={null}>
      <Suspense fallback={<Loading delayMs={1000} embed={true} />}>
        <Loader {...props} />
      </Suspense>
    </FallBackErrorBoundary>
  )
}

export default EditProjectBudgetForm
